<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    intent?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'discord';
    size?: 'sm' | 'md';
    disabled?: boolean;
    /** Shows the busy label and blocks the click without swapping the layout. */
    busy?: boolean;
    type?: 'button' | 'submit';
  }>(),
  { intent: 'secondary', size: 'md', disabled: false, busy: false, type: 'button' },
);

const intents = {
  primary: 'bg-accent text-black border-accent hover:bg-accent/90',
  secondary: 'bg-raised text-dark border-card hover:border-light hover:text-default',
  ghost: 'bg-transparent text-darker border-transparent hover:bg-raised hover:text-default',
  danger: 'bg-transparent text-accent border-accent/40 hover:bg-accent/10',
  discord: 'bg-[#5865f2] text-white border-[#5865f2] hover:bg-[#4752c4] hover:border-[#4752c4]',
};
const sizes = { sm: 'h-11 px-2.5 text-[13px] gap-1.5 sm:h-8', md: 'h-11 px-3.5 text-[13px] gap-2 sm:h-9' };

const classes = computed(() => [
  'inline-flex shrink-0 items-center justify-center rounded-md border font-medium transition-colors duration-150',
  intents[props.intent],
  sizes[props.size],
  (props.disabled || props.busy) && 'pointer-events-none opacity-45',
]);
</script>

<template>
  <button :type="type" :class="classes" :disabled="disabled || busy" :aria-busy="busy || undefined">
    <slot name="icon" />
    <slot />
  </button>
</template>
